import React from 'react';
import useHRCopy from '../hr/i18n/useHRCopy';

export default function EducationDropdown({ value, onChange, error }) {
  const t = useHRCopy().candidate.education;

  return (
    <div>
      <label className="block mb-2 font-medium text-gray-700">
        {t.label} <span className="text-red-500">*</span>
      </label>
      <select
        name="education"
        value={value}
        onChange={onChange}
        aria-label={t.label}
        className={`w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-400 focus:border-blue-400 outline-none transition shadow-sm bg-white font-medium text-gray-900 ${
          error ? 'border-red-400' : 'border-gray-300'
        }`}
      >
        <option value="">{t.placeholder}</option>
        {t.options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      {error && <p className="text-red-500 text-xs mt-1 font-medium">{error}</p>}
    </div>
  );
}
